import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import DiscardForm from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/DiscardForm/component';

export default styled(DiscardForm)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${media.lessThan('extraSmall')`
      background: var(--white);
      padding: ${gridSizes('M')};
      padding-top: 12px !important;
      padding-bottom: 12px !important;
      border-radius: 2px;
  `};

  label {
    width: 100%;
    padding: 24px ${gridSizes('M')};
    margin-bottom: ${gridSizes('M')};
  }

  textarea {
    margin-top: ${gridSizes('M')};
    height: 100px;
  }

  button {
    margin-top: ${gridSizes('M')};
  }
`;
